import React           from 'react';
import { useContext }  from 'react';
import { useLocation } from 'react-router-dom';

import { Navigate } from "react-router-dom";

import { AuthContext }            from 'App';
import internalPaths              from 'routing/internalPaths';
import isAuthorized               from 'routing/Authorization/isAuthorized';
import { PATHS_WO_AUTHORIZATION } from 'routing/internalPaths';


function Authorization(props) {

  const { userInfo } = useContext(AuthContext);

  const location = useLocation();

  let authorized = isAuthorized(userInfo, location);
  let allowed;

  if (PATHS_WO_AUTHORIZATION.includes(location.pathname))
    allowed = true;
  else
    allowed = authorized;

  if (!allowed) {
    const state   = {
      goBackTo: location.pathname
    }
    return <Navigate  to={internalPaths.login} state={state}/>
  }

  return props.children;
}

export default Authorization;